module.exports = __webpack_public_path__ + "static/media/hotel3.2d80e4d0.jpg";